import {captureMessageWrapper} from "./captureMessage";

export const logErrorToSentry = (error: Error | string) => {
    console.error(error);
    if (import.meta.env.VITE_APP_ENV !== 'development') {
        const errorMessage = typeof error === 'string' ? error : (
            error.message ? error.message : JSON.stringify(error)
        );
        captureMessageWrapper(`${errorMessage} \n ${new Error().stack}`);
    }
}
